module.exports = __webpack_public_path__ + "media/images/empty_state-0a9a5031.png";